import React from 'react';
import { AppProvider } from '@shopify/polaris';
import { Provider as AppBridgeProvider } from '@shopify/app-bridge-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@shopify/polaris/build/esm/styles.css';
import enTranslations from '@shopify/polaris/locales/en.json';
import ProductList from './components/ProductList';

// Create a client
const queryClient = new QueryClient();

function App() {
  const host = new URLSearchParams(window.location.search).get('host');

  return (
    <AppBridgeProvider
      config={{
        host: host,
        apiKey: '2920fc81196e42149b0757b5c14c7d31', // This is the public Client ID
        forceRedirect: true
      }}
    >
      <QueryClientProvider client={queryClient}>
        <AppProvider i18n={enTranslations}>
          <ProductList />
        </AppProvider>
      </QueryClientProvider>
    </AppBridgeProvider>
  );
}

export default App;
